module.exports = __webpack_public_path__ + "static/01-225b08776c4d43f80f1e5594a9f12340.jpeg";